import React from "react";
import { useSelector } from "react-redux";
import type { RootState } from "../../../../app/store";
// Import the view component
import CheckoutSteps from "./CheckoutSteps";

// No props needed for this container usually, as it reads from Redux state
const CheckoutStepsContainer: React.FC = () => {
  const currentStep = useSelector(
    (state: RootState) => state.checkout.currentStep
  );
  const completedSteps = useSelector(
    (state: RootState) => state.checkout.completedSteps
  );

  // Define the order of steps
  const stepsOrder: RootState["checkout"]["currentStep"][] = [
    "billing",
    "shipping",
    "payment",
  ];

  return (
    <CheckoutSteps
      steps={stepsOrder}
      currentStep={currentStep}
      completedSteps={completedSteps}
    />
  );
};

export default CheckoutStepsContainer;
